/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React, { ReactElement } from "react";
import styled from "styled-components";

import {
  ApprovalRequest,
  Approver,
  ReviewLog,
} from "../../interfaces/interfaces";
import { off_white } from "../../helperFunctions/styledComponents";

interface ExpandedRowProps {
  awardClaim: ApprovalRequest;
  isExpanded: boolean;
}

interface StyledExpandedRowProps {
  expanded: boolean;
}

interface ApproveDenyProps {
  level: ReviewLog;
}

const StyledExpandedRow = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: ${off_white};
  padding: 0 15px;
  overflow: scroll;
  height: 100%;
`;

const StyledTableRow = styled.tr`
  background: ${off_white};
  overflow: scroll;
  height: 100px;
  top: 0;
  position: ${(p: StyledExpandedRowProps): string => {
    return p.expanded ? "relative" : "absolute";
  }};
  z-index: ${(p: StyledExpandedRowProps): string => {
    return p.expanded ? "1" : "0";
  }};
  opacity: ${(p: StyledExpandedRowProps): string => {
    return p.expanded ? "1" : "0";
  }};
  transform: ${(p: StyledExpandedRowProps): string => {
    return p.expanded ? "translateY(0)" : "translateY(-100%)";
  }};
  * {
    z-index: ${(p: StyledExpandedRowProps): string => {
      return p.expanded ? "1" : "0";
    }};
  }
  transition: ${(p: StyledExpandedRowProps): string => {
    return p.expanded
      ? "opacity 0ms ease-in 150ms, transform 200ms ease-in 0ms, position 0ms ease-in 0ms, z-index 0ms ease-in 200ms"
      : "opacity 0ms ease-in 0ms, transform 200ms ease-in 0ms, position 0ms ease-in 0ms, z-index 0ms ease-in 200ms";
  }};
`;

const ApproveDeny = ({ level }: ApproveDenyProps): ReactElement => {
  if (level.approved_at) {
    return (
      <span>
        Approved by <a href={level.approved_by_path}>{level.approved_by}</a>{" "}
        on&nbsp;
        <b>{level.approved_at}</b>
      </span>
    );
  }
  return (
    <span>
      Denied by <a href={level.denied_by_path}>{level.denied_by}</a> on&nbsp;
      <b>{level.denied_at}</b>
    </span>
  );
};

export default class ExpandedRow extends React.Component<ExpandedRowProps> {
  render(): ReactElement {
    return (
      <StyledTableRow expanded={this.props.isExpanded} className="expandable">
        <td className="expanded-table" colSpan={8}>
          <StyledExpandedRow>
            {this.props.awardClaim?.claim.claimable
              ? this.renderClaimReason()
              : this.renderGiver()}
            <div className="column-header">
              {" "}
              Approval Process
              <p>
                {Array.isArray(this.props.awardClaim?.claim?.approvers[0])
                  ? this.renderMultilevelApprovers()
                  : this.renderApprovers()}
              </p>
            </div>
            <div className="column-header">
              {" "}
              Review Log
              <p>
                {this.props.awardClaim?.claim?.reviewLog?.length
                  ? this.renderReviewLog()
                  : "Pending"}
              </p>
            </div>
          </StyledExpandedRow>
        </td>
      </StyledTableRow>
    );
  }

  renderApprovers = (): ReactElement[] => {
    return (this.props.awardClaim?.claim.approvers as Approver[]).map(
      (approver, i, approverArray) => {
        return (
          <span key={`${approver.name}_${i}`}>
            <a href={`/company/users/${approver.id}`}>{approver.name}</a>
            {i !== approverArray.length - 1 && " OR "}
          </span>
        );
      }
    );
  };

  renderMultilevelApprovers = (): ReactElement[] => {
    return (this.props.awardClaim?.claim.approvers as Approver[][]).map(
      (level, levelIndex) => {
        return (
          <span key={levelIndex}>
            ({levelIndex + 1}){" "}
            {level.map((approver, i, approverArray) => {
              return (
                <span key={`${approver.name}_${levelIndex}_${i}`}>
                  <a href={`/company/users/${approver.id}`}>{approver.name}</a>
                  {i !== approverArray.length - 1 && " OR "}
                </span>
              );
            })}
            <br />
          </span>
        );
      }
    );
  };

  renderClaimReason = (): ReactElement => {
    return (
      <div className="column-header">
        Claim Reason
        <p> {this.props.awardClaim?.claim.reason}</p>
      </div>
    );
  };

  renderGiver = (): ReactElement => {
    return (
      <div className="column-header">
        Award requested by
        <p>
          <a href={this.props.awardClaim?.claim?.giverProfile}>
            {this.props.awardClaim?.claim?.giver}
          </a>
        </p>
      </div>
    );
  };

  renderReviewLog = (): ReactElement[] => {
    return (this.props.awardClaim?.claim.reviewLog as ReviewLog[]).map(
      (level, levelIndex) => {
        return (
          <span key={levelIndex}>
            ({levelIndex + 1}){" "}
            {level.approved_at || level.denied_at ? (
              <ApproveDeny level={level} />
            ) : (
              "Pending"
            )}
            <br />
          </span>
        );
      }
    );
  };
}
